import React, {
    useContext,
    useMemo
} from 'react';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { SgPaymentUtils, SgNumberUtil } from 'saga-modules';
import CommonConstants from 'sg-common-constants';
import messages from './SgEndorsementSummaryInfo.messages';

function SgEndorsementSummaryInfo(props) {
    const {
        productInfo,
        paymentPlanName,
        transactionCost,
        additionalPaymentInfo,
        changesAdded,
        changesRemoved
    } = props;

    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);

    const isAnnual = useMemo(() => {
        return paymentPlanName === CommonConstants.PAYMENT_PLANS.ANNUAL_UPFRONT;
    }, [paymentPlanName]);
    const priceChanged = transactionCost.amount !== 0;
    const hasRefund = transactionCost.amount < 0;
    const isRefundLessThanOrEqualsFivePound = SgPaymentUtils.isRefundLessThanOrEqualsFivePound(transactionCost.amount);
    const isIncreaseLessThanOrEqualsFivePound = SgPaymentUtils.isIncreaseLessThanOrEqualsFivePound(transactionCost.amount);

    return (
        <>
            <div className="sgConfirmationPolicySummaryDetails">
                <div id="productInfoValue" className="sg-flex-div">
                    <h3>
                        {productInfo}
                    </h3>
                </div>
                <ul className="sg-policyInfoDetailsList">
                    {(Array.isArray(changesAdded) && changesAdded.length > 0) && (
                        <ul className="sg-coveragesDetailsList">
                            <h4>{translator(messages.ChangesAdded)}</h4>
                            {changesAdded.map((change) => {
                                return (
                                    <li
                                        key={change.id}
                                    >
                                        <span>{translator(change.message, change.params)}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                    {(Array.isArray(changesRemoved) && changesRemoved.length > 0) && (
                        <ul className="sg-coveragesDetailsList">
                            <h4>{translator(messages.ChangesRemoved)}</h4>
                            {changesRemoved.map((change) => {
                                return (
                                    <li
                                        key={change.id}
                                    >
                                        <span>{translator(change.message, change.params)}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </ul>
                <div className="sg-flex-div">
                    {isAnnual
                        && ((!priceChanged || isRefundLessThanOrEqualsFivePound || isIncreaseLessThanOrEqualsFivePound) ? (
                            <h3>{translator(messages.NoFeeCharged)}</h3>
                        ) : (
                            <h3>
                                {translator(hasRefund ? messages.AmountRefundedLabel : messages.AmountPaidLabel, {
                                    amount: SgNumberUtil.getCurrencyValue(intl, transactionCost, false, true)
                                })}
                            </h3>
                        ))}
                    {!isAnnual
                        && (
                            <ul className="sg-policyInfoDetailsList">
                                { additionalPaymentInfo.firstCompensatingInstallment && (
                                    <li>
                                        <div className="sg-flex-div sg-paid-today">
                                            <span>{translator(messages.NextInstallmentLabel)}</span>
                                            <span id="nextInstallmentValue">
                                                {SgNumberUtil.getCurrencyValue(intl, additionalPaymentInfo.firstCompensatingInstallment)}
                                            </span>
                                        </div>
                                    </li>
                                )}
                                { additionalPaymentInfo.newInstallmentAmount && (
                                    <li>
                                        <div className="sg-flex-div sg-paid-today">
                                            <span>{translator(messages.RemainingInstallmentsLabel)}</span>
                                            <span id="remainingInstallmentsValue">
                                                {SgNumberUtil.getCurrencyValue(intl, additionalPaymentInfo.newInstallmentAmount)}
                                            </span>
                                        </div>
                                    </li>
                                )}
                            </ul>
                        )}
                </div>
            </div>
        </>
    );
}

export default SgEndorsementSummaryInfo;
